require("sticksy/src/sticksy");

export default {
    init() {
    },
    finalize() {

        const sticky_sidebar = new Sticksy('.results-pack-card');
        if ( jQuery(window).width() >= 1024 ) {
            sticky_sidebar.enable();
        } else {
            sticky_sidebar.disable();
        }

        jQuery(window).on('resize', function(){
            if ( jQuery(window).width() >= 1024 ) {
                sticky_sidebar.enable();
            } else {
                sticky_sidebar.disable();
            }
        });

        jQuery('.results-faq-item-question').click( function() {
            jQuery(this).siblings('.results-faq-item-answer').stop().slideToggle();
            jQuery(this).parent('.results-faq-item').toggleClass('open');
        })

        jQuery('.results__learn-more').click(function() {
            jQuery(this).siblings('.results__read-more').slideDown();
            jQuery(this).remove();
        });

        // make add to cart ajax
        jQuery('.pack_add_to_cart_button').click(function(event){
            event.preventDefault();

            jQuery('.pack_add_to_cart_button').addClass('waiting');

            jQuery.ajax({
                type: "POST",
                url: window.addUrl,
                data: { consultation_products: window.consultation_products, consultation_id: window.consultation_id }
            })
            .done(function () {
                window.location = window.checkoutUrl;
                jQuery('.pack_add_to_cart_button').removeClass('waiting');
                jQuery('.pack_add_to_cart_button').addClass('disabled');
            });
        });

        jQuery('.ingredients-link a').click(function(e) {
            e.preventDefault();

            const href = jQuery(this).attr('href');
            jQuery('html, body').animate({
                scrollTop: jQuery(href).offset().top
            }, 300);
        });
    }
};



// WEBPACK FOOTER //
// ./js/routes/woocommerce-account-view-consultation.js